import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';

const Home = lazy(() => import('../../container/dashboard/Profile'));
const Pricing = lazy(() => import('~/container/pages/PricingTable'));
const Checkout = lazy(() => import('~/container/pages/PricingTable'));
const Orders = lazy(() => import('~/container/pages/Orders'));
// const Profile = lazy(() => import('~/container/pages/overview/UserCard'));
const Admin = () => {
  // const { path } = useRouteMatch();

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        {/* <Route path="/profile" component={Profile} /> */}
        <Route path="/pricing" component={Pricing} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/billings" component={Orders} />
        <Route exact path="/" component={Home} />
      </Suspense>
    </Switch>
  );
};

export default withAdminLayout(Admin);
